import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "./Layout"

const LayoutData = ({ ...props }) => {
  const {
    prismicLayout,
    latestBlogs,
    latestQuestions,
    events,
    innovationChallenges,
  } = useStaticQuery(
    graphql`
      query {
        prismicLayout {
          data {
            logo {
              gatsbyImageData(layout: CONSTRAINED, width: 55)
              url
            }
            header_navigation {
              label
              link_url
              sub_links
            }
            header_body {
              ... on PrismicLayoutDataHeaderBodyButton {
                id
                primary {
                  action_label
                  action_url {
                    url
                    uid
                    target
                    type
                  }
                }
              }
            }
            footer_body {
              ... on PrismicLayoutDataFooterBodyNavItem {
                id
                primary {
                  label
                }
                items {
                  label
                  link_url {
                    type
                    target
                    uid
                    url
                    document {
                      ... on PrismicBlog {
                        id
                        type
                        uid
                        data {
                          category {
                            uid
                          }
                        }
                      }
                    }
                  }
                }
                slice_type
              }
            }
          }
        }
        latestBlogs: allPrismicBlog(
          sort: { fields: first_publication_date, order: DESC }
          limit: 2
        ) {
          edges {
            node {
              uid
              type
              data {
                title {
                  text
                }
                category {
                  uid
                }
              }
            }
          }
        }
        latestQuestions: allPrismicQuestion(
          sort: { fields: first_publication_date, order: DESC }
          limit: 2
        ) {
          edges {
            node {
              data {
                question {
                  text
                }
                answer {
                  text
                }
              }
              id
              uid
            }
          }
        }
        events: allPrismicEvent(
          sort: { fields: data___start_date, order: DESC }
        ) {
          edges {
            node {
              id
              uid
              data {
                title {
                  text
                }
                description
                start_date
                end_date
                custom_date
                organiser
                city
              }
              type
            }
          }
        }
      }
    `
  )

  const latestBlogsFormatted = latestBlogs?.edges.map(item => item.node)
  const latestQuestionsFormatted = latestQuestions.edges.map(item => item.node)
  const eventsList = events.edges.map(item => item.node)

  const futureEvents = eventsList
    .filter(item => item.data.start_date >= new Date().toISOString())
    .reverse()
    .slice(0, 4)

  const {
    logo,
    header_navigation: headerNavigation,
    header_body: headerBody,
    footer_body: footerBody,
  } = prismicLayout.data

  const headerData = { logo, headerNavigation, headerBody }
  const footerData = {
    footerBody,
    latestBlogs: latestBlogsFormatted,
    latestQuestions: latestQuestionsFormatted,
    futureEvents,
  }

  return <Layout headerData={headerData} footerData={footerData} {...props} />
}

LayoutData.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutData
